function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Form, Button, Select, Statistic, Descriptions, Modal, Switch, message, Divider, Alert, Upload, List, Typography } from "antd";
import { Cash, ExclamationCircleFill, Upload as UploadIc } from "react-bootstrap-icons";
import Common from "./includes/Common";
import Receipt from "./Receipt";
import moment from "moment";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;

var ManageOrder = function ManageOrder(_ref) {
  var handler = _ref.handler,
      customer = _ref.customer,
      items = _ref.items,
      queueItem = _ref.queueItem;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      itemOptions = _useState2[0],
      setItemOptions = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      itemsTotalAmount = _useState4[0],
      setItemsTotalAmount = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedItems = _useState6[0],
      setSelectedItems = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      errorMessage = _useState8[0],
      setErrorMessage = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      successMessage = _useState10[0],
      setSuccessMessage = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      serviceTree = _useState12[0],
      setServiceTree = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isFormLoading = _useState14[0],
      setIsFormLoading = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      file = _useState16[0],
      setFile = _useState16[1];

  var _useState17 = useState(customer.category == 0),
      _useState18 = _slicedToArray(_useState17, 2),
      companyDisabled = _useState18[0],
      setCompanyDisabled = _useState18[1];

  var _useState19 = useState(customer.category == 0),
      _useState20 = _slicedToArray(_useState19, 2),
      uploadDisabled = _useState20[0],
      setUploadDisabled = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      companies = _useState22[0],
      setCompanies = _useState22[1];

  var _useState23 = useState([]),
      _useState24 = _slicedToArray(_useState23, 2),
      companyOptions = _useState24[0],
      setCompanyOptions = _useState24[1];

  var _useState25 = useState([]),
      _useState26 = _slicedToArray(_useState25, 2),
      rdata = _useState26[0],
      setRdata = _useState26[1];

  var _useState27 = useState(customer.company),
      _useState28 = _slicedToArray(_useState27, 2),
      userCompany = _useState28[0],
      setUserCompany = _useState28[1];

  var _useState29 = useState(0),
      _useState30 = _slicedToArray(_useState29, 2),
      receipAmount = _useState30[0],
      setReceipAmount = _useState30[1];

  var handleItemChange = function handleItemChange(value) {
    var amount = 0;
    setSelectedItems(value);
    value.forEach(function (e) {
      items.forEach(function (i) {
        if (i.business_account_medical_item.id == e) amount += i.business_account_medical_item.base_price;
      });
    });
    setRdata(rdata.filter(function (d) {
      return value.includes(d.id);
    }));
    setItemsTotalAmount(amount);
  };

  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    }
  };
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];

  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      setCompanyDisabled(false);
      form.setFieldsValue(customer.company.id);
      setUploadDisabled(false);
      setUserCompany(companies.filter(function (c) {
        return c.id == customer.company.id;
      })[0]);
    } else {
      setUploadDisabled(true);
      setCompanyDisabled(true);
      setUserCompany(null);
    }
  };

  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };

  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  var onFinish = function onFinish(values) {
    var formData = new FormData();
    formData.append('items', values.items);
    formData.append('customer_id', customer.id);
    formData.append("user_id", Common.currentUser.id);
    formData.append('file', file);
    formData.append("amount", itemsTotalAmount);
    formData.append("category", values.category);
    formData.append("company_id", values.company_id);

    if (values.category == 1) {
      setUserCompany(companies.filter(function (c) {
        return c.id == values.company_id;
      })[0]);
      formData.append('company_part', itemsTotalAmount * userCompany.rate * 0.01);
      formData.append('patient_part', itemsTotalAmount * (100 - userCompany.rate) * 0.01);
      setReceipAmount(itemsTotalAmount * (100 - userCompany.rate) * 0.01);
    } else {
      formData.append("patient_part", itemsTotalAmount);
      formData.append("company_part", 0);
      setReceipAmount(itemsTotalAmount);
    }

    formData.append("queue_id", queueItem.id);
    setErrorMessage('');
    setSuccessMessage('');
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        options: values.items,
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        execOrder(formData);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };

  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'processorder', formData).then(function (response) {
      setIsFormLoading(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
        printR();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormLoading(false);
      setErrorMessage(error.toString());
    });
  };

  useEffect(function () {
    var ar = new Array();
    var amount = 0;
    setCompanies([]);
    setSelectedItems(items);
    items.forEach(function (e) {
      setItemOptions(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          value: e.business_account_medical_item.id,
          label: e.business_account_medical_item.label
        }]);
      });
      setRdata(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          id: e.business_account_medical_item.id,
          label: e.business_account_medical_item.label + " - " + e.business_account_medical_item.base_price.toLocaleString('fr') + " GNF"
        }]);
      });
      ar.push(e.business_account_medical_item.id);
      amount += e.business_account_medical_item.base_price;
    });
    setItemsTotalAmount(amount);
    form.setFieldsValue({
      items: ar
    });
    var cr = axios.get(Common.baseApiUrl + "getcompanylist/" + Common.currentUser.id);
    var st = axios.get(Common.baseApiUrl + "getservicetree/" + Common.currentUser.id);
    axios.all([cr, st]).then(function (response) {
      var crResponse = response[0];
      var stResponse = response[1];

      if (crResponse.data.status == 200) {
        setCompanies(crResponse.data.companyList);
        crResponse.data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else //setCompanyOptions(prev => [...prev, {label: c.company.label+"-"+c.label, value: c.id}]);
            setCompanyOptions(function (prev) {
              return [].concat(_toConsumableArray(prev), [{
                label: c.company == null ? "" : c.company.label + "-" + c.label,
                value: c.id
              }]);
            });
        });
        form.setFieldsValue({
          insurance_company_id: companyOptions
        });
      }

      if (stResponse.data.status == 200) {
        setServiceTree(stResponse.data.services);
      }
    })["catch"](function (error) {});
    form.setFieldsValue({
      category: customer.category
    });
    form.setFieldsValue({
      company_id: customer.company != null ? customer.company.id : null
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [customer != null && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/logo_sos.jpeg",
          style: {
            width: '100%'
          }
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", customer.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", customer.firstname + " " + customer.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Actes / Produit(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) " + receipAmount.toLocaleString('fr')
        }),
        bordered: true,
        dataSource: rdata,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item.label
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), userCompany != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + userCompany.rate.toString() + "% par " + userCompany.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepas - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 7,
          md: 7,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              borderRight: '1px solid #F0F0F0',
              paddingRight: '10px'
            },
            children: [/*#__PURE__*/_jsxs(Form, {
              layout: "vertical",
              form: form,
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "items",
                rules: [{
                  required: true,
                  message: "Champs obligatoire"
                }],
                children: /*#__PURE__*/_jsx(Select, {
                  onChange: handleItemChange,
                  mode: "multiple",
                  optionLabelProp: "label",
                  options: itemOptions
                })
              }), /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "category",
                    label: "Cat\xE9gorie",
                    rules: [{
                      required: true,
                      message: 'Choisir la catégorie'
                    }],
                    children: /*#__PURE__*/_jsx(Select, {
                      showSearch: true,
                      onChange: onCategorieChanged,
                      optionLabelProp: "label",
                      defaultValue: [customer.category],
                      value: [customer.category],
                      optionFilterProp: "label",
                      filterOption: function filterOption(input, option) {
                        return option.label.toLowerCase().includes(input.toLowerCase());
                      },
                      options: categoryOptions
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    name: "company_id",
                    label: "Prise en charge",
                    children: /*#__PURE__*/_jsx(Select, {
                      onChange: onCompanyChanged,
                      disabled: companyDisabled,
                      defaultValue: [customer.company != null ? customer.company.id : null],
                      value: [customer.company != null ? customer.company.id : null],
                      showSearch: true,
                      options: companyOptions
                    })
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Form.Item, {
                    label: "Bon de prise en charge",
                    children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                      children: /*#__PURE__*/_jsx(Button, {
                        disabled: uploadDisabled,
                        icon: /*#__PURE__*/_jsx(UploadIc, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Charger le bon"
                        })
                      })
                    }))
                  })
                })]
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  disabled: selectedItems.length == 0,
                  size: "large",
                  loading: isFormLoading,
                  type: "primary",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "VALIDER"
                  })
                })
              }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
                type: "error",
                banner: true,
                message: errorMessage
              }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
                type: "success",
                banner: true,
                message: successMessage
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
              className: "price_box",
              children: /*#__PURE__*/_jsx(Statistic, {
                size: "large",
                title: "Montant (GNF)",
                value: itemsTotalAmount,
                prefix: /*#__PURE__*/_jsx(Cash, {
                  size: 30
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            children: [customer && /*#__PURE__*/_jsxs(Descriptions, {
              column: 2,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                labelStyle: {
                  fontWeight: 'Bold'
                },
                span: 2,
                contentStyle: {
                  fontWeight: 'Bold'
                },
                label: "ID PATIENT",
                children: customer.idnumber
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Pr\xE9nom"
                }),
                children: customer.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Nom"
                }),
                children: customer.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Tel."
                }),
                children: customer.mobile.toString().slice(3)
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Genre"
                }),
                children: customer.gender == 'F' ? "Femme" : "Homme"
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "D. Naissance"
                }),
                children: /*#__PURE__*/_jsx(Moment, {
                  format: "DD/MM/YYYY",
                  children: customer.birthdate
                })
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "Profession"
                }),
                children: customer.job
              })]
            }), /*#__PURE__*/_jsx(Divider, {}), queueItem && queueItem.department.dcode == "LUN" && items.length > 0 && items[0].bilan_prescrit != null && /*#__PURE__*/_jsx("div", {
              style: {
                background: "#FBDC76",
                padding: "10px"
              },
              className: "cool-radius",
              children: /*#__PURE__*/_jsxs(Descriptions, {
                column: 2,
                title: /*#__PURE__*/_jsx("b", {
                  children: "DETAILS LUNETTE"
                }),
                children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "EP"
                  }),
                  children: [items[0].bilan_prescrit.glass_prescription_details.ep, " mm"]
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "SPHERE GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.sphere_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CYLINDRE GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.cylindre_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ADDITION GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.addition_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "AXE GAUCHE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.axe_g
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "SPHERE DROITE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.sphere_d
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "CYLINDRE DROIT"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.cylindre_d
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ADDITION DROITE"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.addition_d
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "AXE DROIT"
                  }),
                  children: items[0].bilan_prescrit.glass_prescription_details.axe_d
                })]
              })
            })]
          })
        })]
      })
    })]
  });
};

export default ManageOrder;